/**
 * 数据加密工具
 * 使用 AES-256-CBC 对称加密算法
 */
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'R@NDOM_CRYPTO_K!';
const IV = 'R@NDOM_IV_VALUE!';

/**
 * 加密数据
 * @param {Object} data - 需要加密的数据对象
 * @returns {String} 返回 Base64 编码的加密字符串
 */
export function encryptData(data) {
  try {
    // 将数据对象转换为 JSON 字符串
    const jsonStr = JSON.stringify(data);

    // 将密钥和 IV 转换为 WordArray
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    const iv = CryptoJS.enc.Utf8.parse(IV);

    // 使用 AES 加密
    const encrypted = CryptoJS.AES.encrypt(jsonStr, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // 返回 Base64 编码的加密结果
    return encrypted.toString();
  } catch (error) {
    console.error('数据加密失败:', error);
    throw error;
  }
}

/**
 * 解密数据（预留，客户端一般不需要解密）
 * @param {String} encryptedData - Base64 编码的加密字符串
 * @returns {Object} 返回解密后的数据对象
 */
export function decryptData(encryptedData) {
  try {
    // 将密钥和 IV 转换为 WordArray
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    const iv = CryptoJS.enc.Utf8.parse(IV);

    // 解密
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // 将解密结果转换为 UTF-8 字符串
    const jsonStr = decrypted.toString(CryptoJS.enc.Utf8);

    // 解析 JSON 字符串为对象
    return JSON.parse(jsonStr);
  } catch (error) {
    console.error('数据解密失败:', error);
    throw error;
  }
}

export default {
  encryptData,
  decryptData
};



// WEBPACK FOOTER //
// ./src/utils/crypto.js